/**
 * Extrai o caminho do objeto no bucket a partir da URL de download do Firebase Storage
 * (`firebasestorage.googleapis.com/.../o/...`).
 */
export function getFirebaseStorageObjectPathFromUrl(url: string): string | null {
  try {
    const u = new URL(url);
    if (!u.hostname.includes("firebasestorage.googleapis.com")) {
      return null;
    }
    const m = u.pathname.match(/\/o\/(.+)$/);
    if (!m) return null;
    return decodeURIComponent(m[1].replace(/\+/g, " "));
  } catch {
    return null;
  }
}

/** Lê arquivo de imagem e devolve base64 puro (sem prefixo data:). */
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const r = reader.result as string;
      const parts = r.split(",");
      resolve(parts.length > 1 ? parts[1] : r);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
